// Wohin der Verweis auf EINE Aufgabe führt.
//
// Eine Aufgabe steht an genau einem Ort:
//   - mit Zeitplan auf der Aufgaben-Seite,
//   - ohne Zeitplan, aber Stufe einer Backup-Kette: auf der Backup-Seite
//     bei ihrer Kette (die Kette löst sie aus, nicht die Uhr),
//   - sonst als Handgriff im Werkzeug-Katalog.
// Ein Verweis muss dorthin führen, wo die Aufgabe steht -- sonst landet man
// auf einer Seite, die sie nicht zeigt. Bis 05.10.2026 kannte nur die Suche
// den Unterschied (und auch sie schickte Ketten-Stufen zu den Werkzeugen);
// der Baum links schickte jede Aufgabe zur Aufgaben-Seite.

export interface AufgabenVerweis {
  id: string;
  effective_schedule?: string | null;
  chain_id?: string | null;
}

/** Hat die Aufgabe einen Zeitplan (und steht damit auf der Aufgaben-Seite)? */
export function hatZeitplan(t: AufgabenVerweis): boolean {
  return (t.effective_schedule ?? "").trim() !== "";
}

// Kanonische Pfade, keine Weiterleitungen: "/tasks" gibt es nur noch als
// Redirect für alte Lesezeichen. In der Shell wurde daraus ein 404-Tab
// (20.08.) -- Weiterleitungen sind für Verweise von außen.
export function aufgabenPfad(t: AufgabenVerweis): string {
  if (hatZeitplan(t)) return `/system/tasks?focus=${encodeURIComponent(t.id)}`;
  if (t.chain_id) return `/system/backups?kette=${encodeURIComponent(t.chain_id)}`;
  return `/system/werkzeuge?focus=${encodeURIComponent(t.id)}`;
}

/** Name der Seite, auf der die Aufgabe steht (für Suchtreffer). */
export function aufgabenSeite(t: AufgabenVerweis): "Tasks" | "Backups" | "Werkzeuge" {
  if (hatZeitplan(t)) return "Tasks";
  return t.chain_id ? "Backups" : "Werkzeuge";
}
